export default __webpack_public_path__ + "static/media/bg-polisport-molds.8502cc09.png";